module.exports = __webpack_public_path__ + "static/img/zeta_template_11.e267a3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_11.png
// module id = uMXz
// module chunks = 1